<section class="container">
<div
  class="card service-card my-5 py-4 px-3 px-md-4 rounded-4 shadow-lg text-center"
  [dir]="language === 'ar' ? 'rtl' : 'ltr'"
>
  <div class="row justify-content-center">
    <div class="col-12 mb-5" *ngIf="data?.title">
      <h3 class="section-title text-center mb-4">
        {{ data.title.split(' ')[0] | translate }}
        <span>{{ data.title.split(' ').slice(1).join(' ') | translate }}</span>
      </h3>
    </div>

    <div class="col-12 d-flex flex-column align-items-center">
      <div class="image-text-wrapper">
        <img
          class="service-img-inline rounded-4 mb-4"
          [src]="data.imageUrl"
          [alt]="data.imageUrlAlt"
          loading="lazy"
          (click)="openImage(data.imageUrl)"
        />
        <div class="summary-content" [innerHTML]="data.htmlContent" *ngIf="data?.htmlContent"></div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="imageModal"
  tabindex="-1"
  aria-hidden="true"
  #imageModalRef
>
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content bg-transparent border-0">
      <div class="modal-body p-0 position-relative">
        <button
          type="button"
          class="btn-close position-absolute top-0 end-0 m-3"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
        <img
          [src]="selectedImage"
          class="img-fluid rounded-4 w-100"
          alt="Preview"
        />
      </div>
    </div>
  </div>
</div>
</section>